<template>
<div v-if="info" class="tab-wrapper">
  <Spin size="large" v-if="loading" class="spin"></Spin>
  <div class="content">
    <div class="item pt16 pb16">
      <h4 class="mb8">签约信息</h4>
      <Row>
        <Col span="8">订单编号：<span class="info">{{info.orderSn}}</span></Col>
        <Col span="8">订单状态：<span class="info">{{info.orderStatus}}</span></Col>
        <Col span="8">项目名称：<span class="info">{{info.projectName}}</span></Col>
        <Col span="8">功能区/房间号：<span class="info">{{info.areaName}}</span></Col>
      </Row>
    </div>

    <div class="item pt16 pb16">
      <h4 class="mb8">报修信息</h4>
      <Row>
        <Col span="8">大类：<span class="info">{{info.categoryName}}</span></Col>
        <Col span="8">物品：<span class="info">{{info.goodsName}}</span></Col>
        <Col span="8">故障标签：<span class="info">{{info.failureName}}</span></Col>
        <Col span="8">空间：<span class="info">{{info.emergencyDegree}}</span></Col>
        <Col span="8">是否返修：<span class="info">{{info.isReworking}}</span></Col>
        <Col span="8">预约上门时间：<span class="info">{{info.reserveTime}}</span></Col>
      </Row>
      <div class="flex"><span class="flex-lable">故障描述：</span><p>{{info.failureDesc}}</p></div>
    </div>

    <div class="item pt16 pb16">
      <h4 class="mb8">维修信息</h4>
      <Row>
        <Col span="8">派单时间：<span class="info">{{info.assignOrderTime}}</span></Col>
        <Col span="8">签到时间：<span class="info">{{info.visitTime}}</span></Col>
        <Col span="8">损坏性质类型：<span class="info">{{info.troubleReason}}</span></Col>
        <!-- <Col span="8">损坏性质描述：<span class="info">{{info.troubleReasonName}}</span></Col> -->
      </Row>
    </div>
    <div class="item pt16 pb16">
      <h4 class="mb8">联系人信息</h4>
      <Row>
        <Col span="8">联系人：<span class="info">{{info.visitLinkman}}</span></Col>
        <Col span="8">联系人电话：<span class="info">{{info.visitMobile}}</span></Col>
        <Col span="8">报修人：<span class="info">{{info.repairsMan}}</span></Col>
      </Row>
    </div>
  </div>
</div>
 
</template>
 
<script type="text/ecmascript-6">

import { getOrderDetail } from 'api/repaire'

export default {
  name:'repairdetail',
   created(){
    this.order_sn = this.$route.query.orderSn
    // this.initData()
  },
  activated(){
    if(this.isActivated){
      this.order_sn = this.$route.query.orderSn
    }
    this.isActivated = true
  },
  watch:{
    order_sn(val){
      this.getDetail(val)
    }
  },
  data () {
    return {
      order_sn:'',
      loading:true,
      isActivated: false,
      info:{ }
    };
  },
 methods:{
    // formatDateTime:formatDateTime
    getDetail(order_sn){
      // 页面loading， 调接口
      this.loading = true
      getOrderDetail(order_sn).then( res => {
        this.info = res.data
      }).finally( () => {
        this.loading = false
      })
    }
 }
 
}
</script>
<style scoped>

.ivu-row{
  line-height: 3;
}
.info {
  padding-left: 8px;
  font-weight: 600;
}
.flex {
  margin-top: 9px;
  margin-bottom: 9px;
}
.flex-lable {
  flex-shrink: 0;
}
</style>

